import { useState, useEffect, Dispatch, SetStateAction, useMemo, useCallback } from "react";
import SearchBar from "../../../../components/Filtering/SearchBar";
import { DataFile } from "../../../../api/models";
import { useGetDataFilesCountDataFileCountGet, useGetDataFilesDataFileGet, useGetDataFileTagsDataFileTagsGet } from "../../../../api/generated/fastAPI";
import FilterBar from "../../../../components/Filtering/FilterBar";
import useDataParams, { GetParamsTypes } from "../../../../hooks/useDataParams";
import { defaultFileParams, defaultFilters } from "../../../../utils/supplementalData";
import PaginatedSelectList, { SelectListOption } from "../../../../components/Filtering/PaginatedSelectList";

export default function SelectFile({
    preselectedFileId,
    isPrefetchLoading,
    selectedFiles,
    setSelectedFiles,
}: {
    preselectedFileId?: string,
    isPrefetchLoading: boolean,
    selectedFiles: DataFile[],
    setSelectedFiles: Dispatch<SetStateAction<DataFile[]>>,
}) {
   
    const getTagsMutation = useGetDataFileTagsDataFileTagsGet();

    const {
        params,
        setParams,
        search,
        filters,
        setPaginationLimit,
        setPaginationOffset
    } = useDataParams({
        defaultParams: defaultFileParams,
        defaultFilters,
        tagsData: getTagsMutation.data as unknown as { [key: string]: string[] },
    })

    const getDataFilesMutation = useGetDataFilesDataFileGet(params as GetParamsTypes);
    const getDataFilesCountMutation = useGetDataFilesCountDataFileCountGet({
        name: (params as GetParamsTypes).name!,
        created_by: (params as GetParamsTypes).created_by!,
        owner: (params as GetParamsTypes).owner!,
        start_date: (params as GetParamsTypes).start_date!,
        end_date: (params as GetParamsTypes).end_date!,
        tag_groups: (params as GetParamsTypes).tag_groups!,
    });
    const [ dataFiles, setDataFiles ] = useState<DataFile[]>([]);

    

    useEffect(() => {
        if (getDataFilesMutation.data) {
            const data = getDataFilesMutation.data as unknown as DataFile[];
            setDataFiles(data);
        }
    }, [getDataFilesMutation.data]);


    // useEffect(() => {
    //     if (dataFiles.length > 0 && preselectedFileId) {
    //         const preselectedFile = dataFiles.find(df => df.file_hash === preselectedFileId);

    //         if (preselectedFile) {
    //             setSelectedFiles([preselectedFile]);
    //         }
    //     }
    // }, [
    //     dataFiles,
    //     preselectedFileId,
    //     setSelectedFiles
    // ]);

    const count = useMemo(() => {
        if (!getDataFilesCountMutation.data) return 0;
        return getDataFilesCountMutation.data as unknown as number;
    }, [getDataFilesCountMutation.data]);

    const availableOptions: SelectListOption[] = useMemo(() => {
        if (dataFiles.length === 0) return [];
        return dataFiles.map(ds => ({ id: ds.file_hash!, name: ds.name ?? '' }))
    }, [dataFiles]);

    const chosenOptions: SelectListOption[] = useMemo(() => {
        if (selectedFiles.length === 0) return [];
        return selectedFiles.map(ds => ({ id: ds.file_hash!, name: ds.name ?? '' }));
    }, [selectedFiles]);

    const addFile = useCallback((
        id: string | number,
    ) => {
        if (dataFiles.length === 0) return;

        const chosenFile = dataFiles.find(ds => ds.file_hash === id.toString());

        if (chosenFile) {
            setSelectedFiles([chosenFile])
        }
    }, [dataFiles, setSelectedFiles]);

    const removeFile = useCallback((
        id: string | number,
    ) => {
        setSelectedFiles([]);
    }, [setSelectedFiles]);


    return (
        <>
            <div className="flex flex-col gap-10">
                <div className="flex flex-col justify-start items-start gap-4">
                    <SearchBar
                        label="Search"
                        searchKey="name"
                        searchFn={search}
                    />
                    <FilterBar 
                        filters={filters}
                        setParams={setParams}
                        params={params}
                    />
                </div>
                <PaginatedSelectList 
                    availableOptions={availableOptions} 
                    chosenOptions={chosenOptions}
                    addOption={addFile}
                    removeOption={removeFile}
                    isMultiSelect={false}
                    isLoading={getDataFilesMutation.isLoading || isPrefetchLoading}
                    isCountLoading={getDataFilesCountMutation.isLoading}
                    count={count}
                    setPaginationLimit={setPaginationLimit}
                    setPaginationOffset={setPaginationOffset}
                    params={params as GetParamsTypes}
                    showSelected={preselectedFileId !== undefined ? true : false}
                />
            </div>
        </>
    )
}